import { $fontFamily } from './styles/global';
import { COLORS } from './constants/colors';

export const getTheme = () => ({
  token: {
    colorPrimary: COLORS.$primaryBlue,
    fontFamily: $fontFamily,
    fontSize: 16,
    lineHeight: 1.5,
    fontSizeHeading2: 40,
    fontSizeHeading3: 20,
    fontSizeHeading4: 24,
    fontWeightStrong: 700,
    colorAccent: COLORS.$primaryBlue,  // Blue as accent
    grayShade1: '#F8F8F8',         // Light gray for backgrounds
    grayShade2: '#E0E0E0',         // Medium gray for borders
    mainDark50: '#333333',         // Dark gray for text
    gray: '#A0A0A0',               // Medium gray for secondary text
  },
  components: {
    Button: {
      colorPrimary: COLORS.$mainBlack,
      colorPrimaryHover: '#333333',
      colorPrimaryActive: '#333333',
      colorTextSecondary: COLORS.$primaryBlue,
      colorFillSecondary: COLORS.$primaryBlue,
      colorBorderSecondary: COLORS.$primaryBlue,
    },
    Select: {
      colorPrimary: COLORS.$primaryBlue,
      colorPrimaryHover: COLORS.$primaryBlueHover,
      colorPrimaryActive: COLORS.$primaryBlueDark,
    },
    Checkbox: {
      colorPrimary: COLORS.$primaryBlue,
      colorPrimaryHover: COLORS.$primaryBlueHover,
    },
    Radio: {
      colorPrimary: COLORS.$primaryBlue,
      colorPrimaryHover: COLORS.$primaryBlueHover,
    },
  },
});

export const theme = {
  colors: {
    mainBlack: COLORS.$mainBlack,     // Primary black
    mainRed: COLORS.$mainRed,         // Accent red (heart)
    grayShade1: '#F8F8F8',            // Light gray for backgrounds
    grayShade2: '#E0E0E0',            // Medium gray for borders
    mainDark50: '#333333',            // Dark gray for text
    colorPrimary: COLORS.$mainBlack,
    gray: '#A0A0A0',                  // Medium gray for secondary text
  },
};
